module.exports = __webpack_public_path__ + "img/业务探查.2ad71aae.svg";